import _classPrivateFieldInitSpec from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/esnext.iterator.map.js";
import JsonMapper from "../helpers/JsonMapper";
var _attributes = /*#__PURE__*/new WeakMap();
export default class CustomPixel extends JsonMapper {
  constructor(data) {
    super(data);
    _classPrivateFieldInitSpec(this, _attributes, {
      [CustomPixel.name_attribute_name]: null,
      [CustomPixel.code_attribute_name]: null,
      [CustomPixel.token_attribute_name]: null,
      [CustomPixel.conversion_name_attribute_name]: null
    });
    this.map(data, _classPrivateFieldGet(_attributes, this));
  }
  static getTypeAttributeName() {
    return this.name_attribute_name;
  }
  static getCodeAttributeName() {
    return this.code_attribute_name;
  }
  static getTokenAttributeName() {
    return this.token_attribute_name;
  }
  static getConversionNameAttributeName() {
    return this.conversion_name_attribute_name;
  }
  static getPixelTypes() {
    return [this.FACEBOOK, this.SNAPCHAT, this.TWITTER, this.TIKTOK, this.GOOGLE, this.POSTBACK, this.MICROSOFT_CLARITY, this.GOOGLE_TAG];
  }
  static getPixelConversionOptions(type) {
    switch (type) {
      case this.FACEBOOK:
        return this.FACEBOOK_CONVERSION_OPTIONS;
      case this.TIKTOK:
        return this.TIKTOK_CONVERSION_OPTIONS;
      default:
        return [];
    }
  }
  getType() {
    return this.getAttribute(CustomPixel.name_attribute_name);
  }
  getCode() {
    return this.getAttribute(CustomPixel.code_attribute_name);
  }
  getToken() {
    return this.getAttribute(CustomPixel.token_attribute_name);
  }
  getConversionName() {
    return this.getAttribute(CustomPixel.conversion_name_attribute_name);
  }
}
_defineProperty(CustomPixel, "name_attribute_name", 'name');
_defineProperty(CustomPixel, "code_attribute_name", 'code');
_defineProperty(CustomPixel, "token_attribute_name", 'token');
_defineProperty(CustomPixel, "conversion_name_attribute_name", 'conversion_name');